import React from 'react';
import store from '../../store/store';
import { deleteUsers } from '../../store/actions/actions';
import { NavLink } from 'react-router-dom';

import User from '../../models/user';
import Table from '../table/table';

import './stats.scss';

class Stats extends React.Component {
  unsubscribe: any;

  componentDidMount() {
    this.unsubscribe = store.subscribe(() => this.forceUpdate());
  }

  componentWillUnmount() {
    this.unsubscribe();
  }

  handleClick() {
    store.dispatch(deleteUsers());
  }

  render() {
    const users: User[] = store.getState().users;

    return (
      <section className="stats">
        {users.length === 0 ? (
          <NavLink className="stats-link" to="/game">
            Start
          </NavLink>
        ) : (
          <Table users={users} handleClick={this.handleClick} />
        )}
      </section>
    );
  }
}

export default Stats;
